module.exports = __webpack_public_path__ + "wxMicroService/img/noData@2x.80b28a16.png";